<div
  id="fast-warehouse-handling"
  class="card p-2 animate__animated"
  [ngClass]="cardClass"
  *ngIf="pageLoaded"
>
  <div class="row pb-2 m-0">
    <div
      class="col-sm-4 col-12 order-xxl-1 order-xs-1 order-xl-1 order-lg-1 order-md-1 order-sm-1 order-1 d-flex justify-content-sm-start align-items-sm-start justify-content-center align-items-center flex-wrap align-content-start p-0"
    >
      <h5 class="m-0 mobile-size">
        {{ "FastWarehousingHandling" | translate }}
      </h5>
    </div>
    <div
      class="col-sm-4 col-12 order-xxl-2 order-xs-2 order-xl-2 order-lg-2 order-md-2 order-sm-2 order-3 d-flex justify-content-center align-items-center p-0"
    >
      <div
        class="alert-box w-100 d-flex justify-content-center py-1"
        *ngIf="alarmMessage != ''"
      >
        <p class="alert-message px-2">
          {{ alarmMessage | translate }}
        </p>
      </div>
    </div>
    <div
      class="col-sm-4 col-12 col-sm-4 col-12 order-xxl-3 order-xs-3 order-xl-3 order-lg-3 order-md-3 order-sm-3 order-2 d-flex justify-content-end mb-2 p-0"
    >
    <button
        type="button"
        class="btn btn-icon btn-outline-primary ms-1"
        placement="bottom"
        ngbTooltip="{{ 'WarehouseHandling' | translate }}"
        (click)="goToList()"
      >
        <span class="tf-icons fas fa-clipboard-list"></span>
      </button>
      <button
        type="button"
        class="btn btn-icon btn-outline-primary ms-1"
        placement="bottom"
        ngbTooltip="{{ 'Return-Page' | translate }}"
        (click)="return()"
      >
        <span class="tf-icons fa-solid fa-reply"></span>
      </button>
      
    </div>
  </div>

  <div class="col-12">
    <div
      class="row input-box drug-information-box mt-3 mx-1 p-2 pb-4 pt-3 mb-2"
    >
      <div class="input-box-title-box px-2">
        <div class="shadow-input-box">
          <span>{{ "InventoryInformation" | translate : "" }}</span>
        </div>
      </div>

      <div class="row">
        <label class="col-12 form-label" for="drug-barcode">
          {{ "Barcode" | translate }}
        </label>
        <div class="col-12 p-2 py-0">
          <div class="input-group input-daterange">
            <button
              type="button"
              class="input-group-text"
              data-bs-toggle="collapse"
              [disabled]="!activeAdd"
              data-bs-target="#newDrugCollapseSection"
              aria-expanded="false"
              aria-controls="newDrugCollapseSection"
            >
              <i class="fa fa-plus search-desable"></i>
            </button>
            <input
              type="text"
              id="drug-barcode"
              class="form-control go-to-next"
              autocomplete="off"
              [(ngModel)]="searchBarcode"
              (keyup.enter)="advanceSearch()"
              [attr.placeholder]="'barcode' | translate"
            />
            <button
              type="button"
              class="input-group-text"
              (click)="advanceSearch()"
            >
              <i class="fa fa-search search-desable"></i>
            </button>
          </div>
          <div
            class="collapse"
            id="newDrugCollapseSection"
            #newDrugCollapseSection
          >
            <div class="row">
              <div class="col-lg-12 col-12 py-0">
                <div
                  class="edit-form search-input-box p-4"
                  appClickOutside
                  (clickOutside)="modalIsOpen = false"
                >
                  <label class="form-label" for="drugBrandName">
                    {{ "ProductBrandName" | translate }}
                  </label>

                  <form [formGroup]="drugSearchForm">
                    <div
                      class="input-daterange input-group"
                    >
                      <input
                        id="drugBrandName"
                        type="text"
                        autocomplete="off"
                        appSelectOnFocus
                        formControlName="drugBrandName"
                        class="form-control Focusable iner-Focusable search-input-box"
                        placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                        [(ngModel)]="searchDrugValue"
                        (keyup.escape)="modalIsOpen = false"
                      />
                      <button type="button" class="input-group-text"
                      (click)="saveBarcode()">
                        <i class="fas fa-save"></i>
                      </button>
                    </div>
                  </form>
                  <app-search-box
                    [data]="searchData"
                    [addButton]="true"
                    [fields]="searchFields"
                    [urlName]="'columnsArray_BuySearch'"
                    [paging]="searchPaging"
                    [modalIsOpen]="modalIsOpen"
                    (parentAction)="parentSearchAction($event)"
                  ></app-search-box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-6 col-12 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-drugName">
              {{ "drugName" | translate }}
            </label>
            <input
              type="text"
              id="drug-drugName"
              disabled="disabled"
              class="form-control go-to-next"
              autocomplete="off"
              [(ngModel)]="selectValue.drugName"
              [attr.placeholder]="'drugName' | translate"
            />
          </div>
        </div>
        <div class="col-lg-6 col-12 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-drugPersianName">
              {{ "drugPersianName" | translate }}
            </label>
            <input
              type="text"
              id="drug-drugPersianName"
              class="form-control go-to-next"
              autocomplete="off"
              disabled="disabled"
              [(ngModel)]="selectValue.drugPersianName"
              [attr.placeholder]="'drugPersianName' | translate"
            />
          </div>
        </div>
        <div class="col-xl-2 col-md-6 col-12 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-expireDate">
              {{ "ExpireDate" | translate }}
            </label>
            <div class="datepicker-box">
              <input
                id="drug-expireDate"
                type="text"
                autocomplete="off"
                appSelectOnFocus
                [disabled]="
                  (selectValue.expireDate != null &&
                    selectValue.expireDate != '' &&
                    selectValue.inventoryDetailId != null) ||
                  selectValue.drugId == null ||
                  selectValue.drugId == ''
                "
                class="form-control Focusable iner-Focusable"
                [ngModel]="
                  selectValue.expireDate | dataType : 'justDate' : false
                "
                (ngModelChange)="
                  selectValue.expireDate =
                    this.calendarService.TypeDate('drug-expireDate')
                "
                (keyup.Enter)="SetWithBarcode()"
                [ngModelOptions]="{ standalone: true }"
                placeholder="YYYY/MM/DD"
              />
              <button
                [ngbPopover]="popoverDatapickerexpireDate"
                [autoClose]="'outside'"
                #datePicker="ngbPopover"
              >
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
            <ng-template #popoverDatapickerexpireDate>
              <app-data-picker
                [(childProp)]="selectValue.expireDate"
                (changeVariableMonth)="changeMonth($event)"
              ></app-data-picker>
            </ng-template>
          </div>
        </div>
        <div class="col-xl-2 col-md-6 col-12 py-0">
          <div class="edit-form">
            <label class="form-label" for="drugPackageCount">
              {{ "drugPackageCount" | translate }}
            </label>
            <input
              type="text"
              id="drugPackageCount"
              autocomplete="off"
              disabled
              class="form-control go-to-next"
              [(ngModel)]="selectValue.drugPackageCount"
            />
          </div>
        </div>
        <div class="col-xl-8 col-12">
          <div class="row">
            <div class="col-xl-4 col-md-6 col-12 py-0">
              <div class="edit-form">
                <label class="form-label" for="drug-count">
                  {{ "count" | translate }}
                </label>
                <input
                  type="text"
                  id="drug-count"
                  disabled="disabled"
                  mask="separator.0"
                  thousandSeparator=","
                  autocomplete="off"
                  class="form-control go-to-next"
                  [(ngModel)]="selectValue.count"
                  [attr.placeholder]="'count' | translate"
                />
              </div>
            </div>
            <div class="col-xl-4 col-md-6 col-12 py-0">
              <div class="edit-form">
                <label class="form-label" for="drug-adjustmentCount">
                  {{ "adjustmentCount" | translate }}
                </label>
                <input
                  type="text"
                  id="drug-adjustmentCount"
                  class="form-control go-to-next"
                  autocomplete="off"
                  mask="separator.0"
                  thousandSeparator=","
                  disabled="disabled"
                  [ngModel]="selectValue.adjustment"
                  [attr.placeholder]="'adjustmentCount' | translate"
                />
              </div>
            </div>
            <div class="col-xl-4 col-md-6 col-12 py-0">
              <div class="edit-form">
                <label class="form-label" for="drug-adjustmentCount">
                  {{ "warehouseHandlingCount" | translate }}
                </label>
                <input
                  type="text"
                  id="drug-adjustmentCount"
                  class="form-control go-to-next"
                  autocomplete="off"
                  mask="separator.0"
                  thousandSeparator=","
                  disabled="disabled"
                  [ngModel]="selectValue.warehouseHandlingCount"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="collapse-details-box">
        <button
          class="collapse-button btn btn-outline-secondary p-0 px-1"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#drugCollapseSection"
          [disabled]="!valueList || valueList.length === 0"
          aria-expanded="false"
          aria-controls="drugCollapseSection"
        >
          {{ "MoreDetails" | translate }}
          <i
            class="fas"
            [ngClass]="{
              'fa-angle-double-up':
                drugCollapseSection?.classList?.contains('show'),
              'fa-angle-double-down':
                !drugCollapseSection?.classList?.contains('show')
            }"
          ></i>
        </button>
      </div>
      <div class="collapse" id="drugCollapseSection" #drugCollapseSection>
        <div class="row">
          <table class="table table-bordered table-striped table-details">
            <thead>
              <tr>
                <th scope="col">{{ "Row" | translate }}</th>
                <th scope="col">{{ "drugName" | translate }}</th>
                <th scope="col">{{ "drugPackageCount" | translate }}</th>
                <th scope="col">{{ "expireDate" | translate }}</th>
                <th scope="col">{{ "companyName" | translate }}</th>
                <th scope="col">{{ "count" | translate }}</th>
                <th scope="col">{{ "warehouseHandlingCount" | translate }}</th>
                <th scope="col">{{ "" | translate }}</th>
              </tr>
            </thead>
            <tbody id="rows">
              <ng-container *ngFor="let drug of valueList; let i = index">
                <tr [ngClass]="getRowClassName(drug)">
                  <td>{{ i + 1 }}</td>
                  <td>{{ drug.drugName }}</td>
                  <td>{{ drug.drugPackageCount }}</td>
                  <td>{{ drug.expireDate | dataType : "" : false }}</td>
                  <td>{{ drug.companyName }}</td>
                  <td>{{ drug.count }}</td>
                  <td>{{ drug.warehouseHandlingCount }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-icon btn-outline-primary"
                      (click)="selectAnotherDrug(drug)"
                    >
                      <i class="far fa-hand-paper"></i>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row input-box finance-box mt-3 mx-1 p-2 pt-3 mb-2">
      <div class="input-box-title-box px-2">
        <span>{{ "WarehouseHandlingProcess" | translate : "" }}</span>
      </div>
      <div class="rasing-box p-0 w-auto">
        <button
          type="button"
          class="btn btn-icon"
          [ngClass]="activeMinus ? 'btn-outline-danger' : 'btn-outline-primary'"
          ngbTooltip="{{
            activeMinus
              ? ('Countdown' | translate)
              : ('DirectCounting' | translate)
          }}"
          (click)="changeStatus()"
        >
          <i
            class="fas"
            [ngClass]="activeMinus ? 'fas fa-minus' : 'fas fa-plus'"
          ></i>
          <!-- {{ activeMinus == false ? "Incremental" : "Decreasing" }} -->
        </button>
      </div>
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-sm-4 col-12 p-2 has-action">
              <label class="form-label" for="Number">
                {{ "packageCount" | translate }}
              </label>
              <input
                #count
                id="packageCount"
                type="text"
                autocomplete="off"
                appSelectOnFocus
                mask="separator.0"
                thousandSeparator=","
                class="form-control input-one Focusable iner-Focusable"
                [(ngModel)]="selectValue.countingDrugPackage"
                (keyup)="calcCounting(true)"
              />
              <label class="form-label label-action">
                <i class="fa-solid fa-xmark"></i>
              </label>
            </div>
            <div class="col-sm-4 col-12 p-2 has-action">
              <label class="form-label" for="Number">
                {{ "drugPackage" | translate }}
              </label>
              <input
                id="DrugPackage"
                type="text"
                appSelectOnFocus
                mask="separator.0"
                thousandSeparator=","
                autocomplete="off"
                (keyup)="calcCounting(true)"
                class="form-control input-one Focusable iner-Focusable"
                [(ngModel)]="selectValue.drugPackageCount"
              />
              <label class="form-label label-action col-3">
                <i class="fa-solid fa-equals"></i>
              </label>
            </div>
            <div class="col-sm-4 col-12 p-2">
              <label class="form-label" for="Number">
                {{ "Number" | translate }}
              </label>
              <input
                id="Number"
                type="text"
                autocomplete="off"
                appSelectOnFocus
                mask="separator.0"
                thousandSeparator=","
                (keyup)="calcCounting(false)"
                class="form-control Focusable iner-Focusable"
                [(ngModel)]="selectValue.countingWarehouseHandlingCount"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-12 p-2">
          <div class="edit-form">
            <label class="form-label" for="drug-adjustmentCount">
              {{ "FinalCountingCount" | translate }}
            </label>
            <input
              type="text"
              id="drug-adjustmentCount"
              class="form-control go-to-next"
              autocomplete="off"
              mask="separator.0"
              thousandSeparator=","
              disabled="disabled"
              [ngModel]="selectValue.countingFinalCount"
            />
          </div>
        </div>
        <div class="col-lg-3 col-sm-6 col-12 p-2">
          <div class="edit-form position-relative">
            <label class="form-label" for="drug-adjustmentCount">
              {{ "FinalAdjustmentCount" | translate }}
            </label>
            <input
              type="text"
              id="drug-adjustmentCount"
              class="form-control go-to-next"
              [ngClass]="{ 'is-invalid': selectValue.countingAdjustment < 0 }"
              autocomplete="off"
              mask="separator.0"
              thousandSeparator=","
              disabled="disabled"
              [ngModel]="selectValue.countingAdjustment"
            />
            <span
              class="negative-span"
              *ngIf="selectValue.countingAdjustment < 0"
            >
              <i class="fas fa-minus"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="modalLoading"></app-loading-panel>

  <div
    class="col-12 d-flex justify-content-between align-items-center p-0 mx-2"
  >
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="smartCount()"
    >
      <i class="bx bx-check"></i>
      {{ "Counting" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-label-secondary me-sm-3 me-1"
      (click)="clearFullSelect()"
    >
      <i class="bx bx-eraser"></i>
      {{ "Clear" | translate }}
    </button>
  </div>
</div>
